import { useState, useEffect } from "react";

//Unform e componentes
//Card do dashboard: para voltar ao layout antigo, trocar a linha abaixo pela comentada
//import CardDashboard from "@/frontend/componentes/CardDashboard";
import CardDashboard from "@/frontend/componentes/CardDashboardNovo";
import GridCards from "@/frontend/componentes/GridCards";
import SpinnerLoading from "@/frontend/componentes/Spinner";

//Common
import { SITUACAO_PAGAMENTO, TIPO_SOLICITACAO } from "@/common/constantes";
import { fn_formatarNumero } from "@/common/utils/util";

//Util
import { MENSAGENS_ERRO, showMensagemErro } from "@/frontend/utils/mensagens";

//API
import { api_getCountPagamento } from "@/frontend/services/api/api_others";

//Telas
import TDashboard_detalhe, { COLUNA_DETALHE_CARD } from "./dashboard_detalhe";

/*
 * Cards do dashboard de pagamentos. Os filtros ficam na tela do dashboard (dashboard.jsx), que informa
 * os filtros confirmados e a chave da consulta (a cada consulta a chave muda).
 * @filtros: { data_inicio, data_fim, ids_area } (ids_area: ids das áreas separados por vírgula)
 */
function TDashboard_pag({ filtros, keyConsulta }) {
  //### USE STATE ###
  const [infCards, setInfCards] = useState(null);

  //Card selecionado para apresentar o detalhamento dos pagamentos
  const [cardDetalhe, setCardDetalhe] = useState(null);

  const [loading, setLoading] = useState(false);

  //### VARIÁVEIS AUXILIARES ###
  const CARDS_POR_LINHA = 3;

  //### USE EFFECT ###
  //Listagem dos dados do dashboard
  useEffect(() => {
    if (keyConsulta > 0) {
      //Carrega os dados do dashboard
      async function loadDashboard() {
        try {
          setLoading(true);
          const dataInicio = filtros.data_inicio;
          const dataFim = filtros.data_fim;

          if (dataInicio && dataFim) {
            const filtroIdAreas = `solicitacao_id_area=${filtros.ids_area}`;
            const filtroTipoPag = `solicitacao_tipo=${TIPO_SOLICITACAO.PAGAMENTO}`;

            const situacoesPagPendente = `${SITUACAO_PAGAMENTO.PENDENTE},${SITUACAO_PAGAMENTO.PENDENTE_REAPROVACAO}`;
            //Pagamentos de solicitações com autorização pendente e com operação realizada
            const filtrosPendAutOpRealizada = `${filtroIdAreas}&${filtroTipoPag}&aprovacao_pendente=S&situacao=${situacoesPagPendente}&solicitacao_operacao_realizada=S`;
            const pendAutOpRealizada = await api_getCountPagamento(
              dataInicio,
              dataFim,
              filtrosPendAutOpRealizada,
            );

            //Pagamentos de solicitações com autorização pendente e com operação NÃO realizada
            const filtrosPendAutOpNaoRealizada = `${filtroIdAreas}&${filtroTipoPag}&aprovacao_pendente=S&situacao=${situacoesPagPendente}&solicitacao_operacao_realizada=N`;
            const pendAutOpNaoRealizada = await api_getCountPagamento(
              dataInicio,
              dataFim,
              filtrosPendAutOpNaoRealizada,
            );

            //### PAGAMENTOS AUTORIZADOS ###
            //Pagamentos de solicitações autorizadas com pendência de documento
            const filtrosPendPagDoc = `${filtroIdAreas}&${filtroTipoPag}&aprovacao_pendente=N&situacao=${SITUACAO_PAGAMENTO.PENDENTE}&data_posse=null`;
            const pendPagDoc = await api_getCountPagamento(
              dataInicio,
              dataFim,
              filtrosPendPagDoc,
            );

            //Pagamentos de solicitações autorizadas com pendência de conferência
            const filtrosPendPagConf = `${filtroIdAreas}&${filtroTipoPag}&aprovacao_pendente=N&situacao=${SITUACAO_PAGAMENTO.PENDENTE}&data_posse=notnull`;
            const pendPagConf = await api_getCountPagamento(
              dataInicio,
              dataFim,
              filtrosPendPagConf,
            );

            //Pagamentos de solicitações de controle
            const filtrosPendPagControle = `${filtroIdAreas}&${filtroTipoPag}&aprovacao_pendente=N&situacao=${SITUACAO_PAGAMENTO.CONTROLE}`;
            const pendPagControle = await api_getCountPagamento(
              dataInicio,
              dataFim,
              filtrosPendPagControle,
            );

            //Pagamentos de solicitações autorizadas e conferidos, (EXCETO RECEITA)
            const filtrosTotalPagAq = `${filtroIdAreas}&${filtroTipoPag}&aprovacao_pendente=N&situacao=${SITUACAO_PAGAMENTO.CONFERIDO}`;
            const totalPagAq = await api_getCountPagamento(
              dataInicio,
              dataFim,
              filtrosTotalPagAq,
            );

            setInfCards({
              //Período da consulta que gerou os cards (utilizado no detalhamento)
              data_inicio: dataInicio,
              data_fim: dataFim,

              pend_op_realizada: {
                count: pendAutOpRealizada.count,
                total: pendAutOpRealizada.total,
                count_solicitacoes: pendAutOpRealizada.count_solicitacoes,
                filtros: filtrosPendAutOpRealizada,
              },

              pend_op_nao_realizada: {
                count: pendAutOpNaoRealizada.count,
                total: pendAutOpNaoRealizada.total,
                count_solicitacoes: pendAutOpNaoRealizada.count_solicitacoes,
                filtros: filtrosPendAutOpNaoRealizada,
              },

              pend_pag_conf: {
                count: pendPagConf.count,
                total: pendPagConf.total,
                count_solicitacoes: pendPagConf.count_solicitacoes,
                filtros: filtrosPendPagConf,
              },

              pend_pag_doc: {
                count: pendPagDoc.count,
                total: pendPagDoc.total,
                count_solicitacoes: pendPagDoc.count_solicitacoes,
                filtros: filtrosPendPagDoc,
              },

              pend_pag_controle: {
                count: pendPagControle.count,
                total: pendPagControle.total,
                count_solicitacoes: pendPagControle.count_solicitacoes,
                filtros: filtrosPendPagControle,
              },

              total_pag_aq: {
                count: totalPagAq.count,
                total: totalPagAq.total,
                count_solicitacoes: totalPagAq.count_solicitacoes,
                filtros: filtrosTotalPagAq,
              },
            });
          }
        } catch (error) {
          showMensagemErro(
            MENSAGENS_ERRO.TENTATIVA_OPERACAO,
            "carregar dashboard",
          );
        } finally {
          setLoading(false);
        }
      }

      loadDashboard();
    }
  }, [keyConsulta]);

  //### FUNÇÕES ###
  //Retorna as propriedades do detalhamento do card, para o componente CardDashboard apresentar o botão
  //@chaveCard: Chave do card em infCards. @coluna: Coluna a mais apresentada no detalhamento conforme o card
  function getPropsDetalhar(chaveCard, titulo, subtitulo, coluna) {
    return {
      onDetalhar: () =>
        handleBotaoDetalharCard(chaveCard, titulo, subtitulo, coluna),
      detalharDesabilitado: !(infCards[chaveCard].count > 0),
    };
  }

  //### EVENTOS ###
  //OnClick - Botão Detalhar do card
  function handleBotaoDetalharCard(chaveCard, titulo, subtitulo, coluna) {
    setCardDetalhe({
      ...infCards[chaveCard],
      titulo,
      subtitulo,
      coluna,
      data_inicio: infCards.data_inicio,
      data_fim: infCards.data_fim,
    });
  }

  return (
    <>
      {(loading && <SpinnerLoading mensagem="Carregando" />) || (
        <>
          {infCards != null && (
            <div>
              <GridCards colunas={CARDS_POR_LINHA}>
                <CardDashboard
                  titulo="PENDENTES DE AUTORIZAÇÃO"
                  subtitulo="Operação realizada"
                  {...getPropsDetalhar(
                    "pend_op_realizada",
                    "Pendentes de autorização",
                    "Operação realizada",
                    COLUNA_DETALHE_CARD.SITUACAO,
                  )}
                  valor1={infCards.pend_op_realizada.count}
                  valor2={`R$ ${fn_formatarNumero(infCards.pend_op_realizada.total, 2)}`}
                  valor3={`${infCards.pend_op_realizada.count_solicitacoes} ${infCards.pend_op_realizada.count_solicitacoes == 1 ? "solicitação" : "solicitações"}`}
                  //msgHelpValor2="Valor pagar sem imposto"
                  rodape="Aguardando autorização"
                  nomeIcone={
                    infCards.pend_op_realizada.count > 0 ? "ATENCAO" : "SUCESSO"
                  }
                />

                <CardDashboard
                  titulo="PENDENTES DE AUTORIZAÇÃO"
                  subtitulo="Operação não realizada"
                  {...getPropsDetalhar(
                    "pend_op_nao_realizada",
                    "Pendentes de autorização",
                    "Operação não realizada",
                    COLUNA_DETALHE_CARD.SITUACAO,
                  )}
                  valor1={infCards.pend_op_nao_realizada.count}
                  valor2={`R$ ${fn_formatarNumero(infCards.pend_op_nao_realizada.total, 2)}`}
                  valor3={`${infCards.pend_op_nao_realizada.count_solicitacoes} ${infCards.pend_op_nao_realizada.count_solicitacoes == 1 ? "solicitação" : "solicitações"}`}
                  //msgHelpValor2="Valor pagar sem imposto"
                  rodape="Aguardando autorização"
                  nomeIcone={
                    infCards.pend_op_nao_realizada.count > 0
                      ? "ATENCAO"
                      : "SUCESSO"
                  }
                />

                <CardDashboard
                  titulo="PENDENTES DE POSSE"
                  {...getPropsDetalhar(
                    "pend_pag_doc",
                    "Pendentes de posse",
                    null,
                    null,
                  )}
                  valor1={infCards.pend_pag_doc.count}
                  valor2={`R$ ${fn_formatarNumero(infCards.pend_pag_doc.total, 2)}`}
                  valor3={`${infCards.pend_pag_doc.count_solicitacoes} ${infCards.pend_pag_doc.count_solicitacoes == 1 ? "solicitação" : "solicitações"}`}
                  rodape="Aguardando confirmação de posse"
                  nomeIcone={
                    infCards.pend_pag_doc.count > 0 ? "ATENCAO" : "SUCESSO"
                  }
                />
              </GridCards>

              <br />

              <GridCards colunas={CARDS_POR_LINHA}>
                <CardDashboard
                  titulo="PENDENTES DE CONFERÊNCIA"
                  {...getPropsDetalhar(
                    "pend_pag_conf",
                    "Pendentes de conferência",
                    null,
                    COLUNA_DETALHE_CARD.DATA_POSSE,
                  )}
                  valor1={infCards.pend_pag_conf.count}
                  valor2={`R$ ${fn_formatarNumero(infCards.pend_pag_conf.total, 2)}`}
                  valor3={`${infCards.pend_pag_conf.count_solicitacoes} ${infCards.pend_pag_conf.count_solicitacoes == 1 ? "solicitação" : "solicitações"}`}
                  rodape="Aguardando conferência"
                  nomeIcone={
                    infCards.pend_pag_conf.count > 0 ? "ATENCAO" : "SUCESSO"
                  }
                />

                <CardDashboard
                  titulo="CONTROLES"
                  {...getPropsDetalhar(
                    "pend_pag_controle",
                    "Controles",
                    null,
                    null,
                  )}
                  valor1={infCards.pend_pag_controle.count}
                  valor2={`R$ ${fn_formatarNumero(infCards.pend_pag_controle.total, 2)}`}
                  valor3={`${infCards.pend_pag_controle.count_solicitacoes} ${infCards.pend_pag_controle.count_solicitacoes == 1 ? "solicitação" : "solicitações"}`}
                  rodape="Aguardando confirmação de posse"
                  nomeIcone={
                    infCards.pend_pag_controle.count > 0 ? "ATENCAO" : "SUCESSO"
                  }
                />

                <CardDashboard
                  titulo="PAGAMENTOS FINALIZADOS"
                  {...getPropsDetalhar(
                    "total_pag_aq",
                    "Pagamentos finalizados",
                    null,
                    COLUNA_DETALHE_CARD.DATA_CONFERENCIA,
                  )}
                  valor1={`R$ ${fn_formatarNumero(infCards.total_pag_aq.total, 2)}`}
                  valor3={`${infCards.total_pag_aq.count} ${infCards.total_pag_aq.count == 1 ? "pagamento" : "pagamentos"} / ${infCards.total_pag_aq.count_solicitacoes} ${infCards.total_pag_aq.count_solicitacoes == 1 ? "solicitação" : "solicitações"}`}
                  nomeIcone="CHECK"
                />
              </GridCards>
            </div>
          )}
        </>
      )}

      {/* MODAL DETALHAMENTO DO CARD */}
      {cardDetalhe && (
        <div>
          <TDashboard_detalhe
            modalOpen={cardDetalhe != null}
            toggleModal={() => setCardDetalhe(null)}
            card={cardDetalhe}
          />
        </div>
      )}
    </>
  );
}

export default TDashboard_pag;
